import Typed from 'typed.js';
var Smorgasbord = {};
var header = document.querySelector('.js-header');
Smorgasbord.init = function () {
  window.addEventListener('load', function () {
    Smorgasbord.typeText($('.js-typedSmorgasbord-wrapper'));
  });
};
Smorgasbord.typeText = function (typedWrapper) {
  if (!typedWrapper) return;
  $.each(typedWrapper, function (index) {
    var _this = $(this);
    var typedStrings = '#' + _this.find('.typedSmorgasbord-strings').attr('id');
    var typedEl = '#' + _this.find('.typedSmorgasbord').attr('id');
    var typeSection = _this.closest('section');
    var isInit = _this.attr('data-attr');
    var quoteHeight = _this.find('.typedSmorgasbord-strings').outerHeight(true);
    var authorHeight = _this.find('.smorgasbord-blockquote-author').outerHeight(true);
    var totalHeight = quoteHeight + authorHeight + "px";
    if (matchMedia('screen and (max-width: 991px)').matches) {
      _this.css('height', totalHeight);
    }
    document.addEventListener('scroll', function () {
      var docElem = document.documentElement;
      var docBody = document.body;
      var scrollTop = (docBody.scrollTop || docElem.scrollTop) + (window.innerHeight - header.offsetHeight);
      var typePos = typeSection.offset().top;
      if (typePos <= scrollTop) {
        if (isInit == 0) {
          _this.find('.typedSmorgasbord-strings').addClass('d-none');
          var typed = new Typed(typedEl, {
            stringsElement: typedStrings,
            typeSpeed: 30,
            fadeOut: true,
            onComplete: function onComplete() {
              setTimeout(function () {
                _this.closest('.smorgasbord-blockquote-wrapper').addClass('is-done');
              }, 500);
            }
          });
          isInit = 1;
        }
      }
    });
  });
};
Smorgasbord.init();


// WEBPACK FOOTER //
// ./scripts/components/interstellar/smorgasbord.js